import { Component, ElementRef, TemplateRef, ViewChild } from "@angular/core";
import { ShippingLineService } from "../services/shippinglines.service";
import { InfoSectionService } from "../services/infosection.service";
import { FormBuilder, Validators } from "@angular/forms";
import gsap from 'gsap';
import { Port } from "src/app/models/Port";
import { Country } from "src/app/models/Country";
import { PortService } from "src/app/core-services/port.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { portcalvm } from "src/app/models/portcalpostmodel";
import { CustomEventTitleFormatter } from "../../portfullcalendar/CalendarEventTitleFormatterOvrride";
import * as moment from 'moment';

import {
  CalendarView,
  CalendarEventTitleFormatter} from 'angular-calendar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from "@angular/common";
import { Subject } from "rxjs";
import { UserRole, UserSelectedPlan, DataParam, OpenSearchScreen, OpenSearchFinderFields } from "src/app/Enum/Enum";
import { LandingPageSearchModel } from "src/app/models/LandingPageSearchModel";
import { UserService } from "src/app/core-services/user.service";
import { ConfirmationService } from "primeng/api";
import { OpenSearchService } from "../services/open-searches.service";
import { FreeSearchConfigVM, OpenSearchModel } from "../../admin/open-searches/model/open-search.model";
import { Result } from "src/app/models/ResultModel";
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  templateUrl: "./search-result-splash.component.html",
  styleUrls: ["./search-result-splash.component.scss"],
  providers: [ShippingLineService, InfoSectionService, DatePipe, {
    provide: CalendarEventTitleFormatter,
    useClass: CustomEventTitleFormatter,
  },
    ConfirmationService],
  styles: [
    `.cell-totals {
      margin: 5px;
      text-align: center;
    }
    .badge {
      margin-right: 5px;
    }
    .custom-event {
      border: 1px solid silver;
    }
  `
  ]
})
export class LandingSplashComponent {
  shippingLines = [];
  infoSections = [];
  view: CalendarView = CalendarView.Week;
  totalSearchCount: number = 0;
  isBasicPlan: boolean = false;
  isLoggedIn: boolean = false;
  registerUrl: string;
  currentUserDetails: any;
  BremerPortId: number = 0;
  isBasicPlanOver = false;
  displayStyle= '';
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @ViewChild('myModel', { static: true }) myModal :ElementRef;
  constructor(
    private modal: NgbModal,
    public datepipe: DatePipe,
    private shippingLineService: ShippingLineService,
    private infoSectionService: InfoSectionService,
    private fb: FormBuilder,
    private portService: PortService,
    private router: Router,
    private toastr: ToastrService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private openSearchService: OpenSearchService,
    private deviceService: DeviceDetectorService
  ) {
    this.registerUrl = window.location.origin + '/signup';
    var currentUser = localStorage.getItem('currentUser');
    let landingSearchJson = localStorage.getItem(DataParam.LandingPageSearch.toString());

    this.portForm.controls.date.setValue(new Date() as any);
    if (currentUser != null && currentUser != undefined) {
      this.isLoggedIn = true;
      this.currentUserDetails = JSON.parse(currentUser);
      if (this.currentUserDetails != null && this.currentUserDetails.usersDetailsVM != null && (this.currentUserDetails.usersDetailsVM.userRole != null && this.currentUserDetails.usersDetailsVM.userRole != '')) {
        if (this.currentUserDetails.usersDetailsVM.userRole == UserRole.User) {
          if (this.currentUserDetails.usersDetailsVM.planId != null && this.currentUserDetails.usersDetailsVM.planId == UserSelectedPlan.Basic) {
            this.totalSearchCount = this.currentUserDetails.usersDetailsVM.totalSearchCount;
            this.isBasicPlan = true;
          }
        }
      }
    }
  }

  ports: Port[];
  portsData: Port[] = [];
  portCount: number;
  portName: string;
  submitted: boolean = false;
  shippinglineslist: any;
  voyagelist: any;
  vesselslist: any;
  minDate: Date;
  maxDate: Date;
  rageYears: string;
  events: any;
  viewDate: Date = new Date();
  month: number = -1;
  transit = new portcalvm();
  refresh: Subject<any> = new Subject();

  masterDestinationCountries: Country[] = [];
  masterDestinationPorts: Port[] = [];
  masterSourceCountries: Country[] = [];
  masterSourcePorts: Port[] = [];
  landingPageSearch = new LandingPageSearchModel();
  selectedOpenSearch :LandingPageSearchModel;
  isOpenSearch=false;
  isDefaultValues=false;
  isOpenSearchCallCompleted =false;
  portForm = this.fb.group({
    toCountry: ["", Validators.required],
    fromCountry: ["", Validators.required],
    fromPort: ["", Validators.required],
    toPort: ["", Validators.required],
    date: ["", Validators.required]
  });

  portCalform = this.fb.group({
    PortId: ["", Validators.required],
    vesselsId: ["", Validators.required],
    voyageId: ["", Validators.required],
    shippinglineId: ["", Validators.required]
  });
  openSearches: OpenSearchModel[] = [];
  // convenience getter for easy access to form fields
  get f() {
    return this.portForm.controls;
  }

  onSearch() {
    if (this.isBasicPlanOver) {
      this.confirm('You have finished the free searches.Please upgrade to get unlimited search');
    } else {
      let url = "/searchresult/";
      this.router.navigate([url]);
    }
  }

  searchSchedules() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.isBasicPlanOver) {
      this.confirm('You have finished the free searches.Please upgrade to get unlimited search');
    }
    else if (this.portForm.invalid) {
      if (this.portForm.controls.toCountry.status == 'INVALID') {
        this.toastr.error("Please enter to country", "Error!");
        return;
      }

      if (this.portForm.controls.toPort.status == 'INVALID') {
        this.toastr.error("Please enter to port", "Error!");
        return;
      }

      if (this.portForm.controls.fromCountry.status == 'INVALID') {
        this.toastr.error("Please enter from country", "Error!");
        return;
      }

      if (this.portForm.controls.fromPort.status == 'INVALID') {
        this.toastr.error("Please enter from port", "Error!");
        return;
      }

      if (this.portForm.controls.date.status == 'INVALID') {
        this.toastr.error("Please enter date", "Error!");
        return;
      }
    }
    else {
      if (this.isBasicPlan == true) {
        this.totalSearchCount = (this.totalSearchCount != null && this.totalSearchCount > 0) ? this.totalSearchCount : 0
        this.totalSearchCount = this.totalSearchCount + 1;
        this.currentUserDetails.usersDetailsVM.totalSearchCount = this.totalSearchCount;
        localStorage.setItem("currentUser", JSON.stringify(this.currentUserDetails));
      }

      var data: any = this.portForm.value;
      if (
        data != null &&
        data.toCountry != null &&
        data.fromCountry != null &&
        data.fromPort != null &&
        data.toPort != null
      ) {
        let date: any = this.dateConvert(this.portForm.value.date);
        if (data.fromCountry.id > 0 && data.toCountry.id > 0 && data.fromPort.length > 0 && data.toPort.length > 0) {

          this.landingPageSearch.date = date;
          this.landingPageSearch.toCountryId = data.toCountry.id;
          this.landingPageSearch.toPortIds = data.toPort.map(x => x.id);
          this.landingPageSearch.fromCountryId = data.fromCountry.id;
          this.landingPageSearch.fromPortIds = data.fromPort.map(x => x.id);
          this.landingPageSearch.isSearch = true;
          localStorage.setItem(DataParam.LandingPageSearch.toString(), JSON.stringify(this.landingPageSearch))

          let url = "/searchresult";
          this.router.navigate([url]);

        } else {
          this.toastr.error("Incorrect port", "Error");
        }
      }
    }
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  ngAfterViewInit() {
    gsap.to('.content', { y: 0, opacity: 1, duration: 0.85 });
    const isMobile = this.deviceService.isMobile();
    if(isMobile){
      //TODO Removed warning message for mobile device.
      //this.displayStyle='';
      //this.myModal.nativeElement.className = 'modal fade show request-modal';
    }
  }

  resetvalues(){
    this.myModal.nativeElement.className ="modal fade"
  }

  ngOnInit() {
    
    this.getOpenSearches();
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
    // if (this.currentUserDetails && this.currentUserDetails.usersDetailsVM.userRole == UserRole.User) {
    //   this.checkFreeSearches();
    // }

    // Get all shippinglines logos
    this.shippingLineService
      .getJSON()
      .subscribe(r => this.shippingLines.push(...r));
    // Get all shippinglines logos
    this.infoSectionService
      .getJSON()
      .subscribe(i => this.infoSections.push(...i));
  }

  getshippingline() {
    this.portService.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.shippinglineslist = response.content;
      } else {
        this.shippinglineslist = null;
      }
    });
  }
  refreshView(): void {
    this.refresh.next(null);
  }

  confirm(message) {
    this.confirmationService.confirm({
      message: message,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.router.navigateByUrl('/planselection');
      },
      reject: () => {
      }
    });
  }

  // checkFreeSearches() {
  //   this.userService.getUserPlan(this.currentUserDetails.usersDetailsVM.id).subscribe((result: any) => {
  //     const expireyDate = moment(result.planExpiryDate);
  //     if (result && result.planId == 1) {
  //       if (result.totalSearchCount >= 5) {
  //         this.isBasicPlanOver = true;
  //       }
  //     }
  //   });
  // }

  getOpenSearches() {
    var currentUser = localStorage.getItem('currentUser');
    if (!currentUser) {
      this.openSearchService.getOpenSearchByFeatureName(OpenSearchScreen.Finder).subscribe((res: Result<FreeSearchConfigVM>) => {
        if (res && res.data && res.data) {
          this.openSearches = res.data.openSearchConfig;
          this.selectedOpenSearch =new LandingPageSearchModel();
          if(this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromCountry).enableDefaultValues)
            {
          this.selectedOpenSearch.fromCountryId = this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromCountry).fieldValue;
          this.selectedOpenSearch.toCountryId = this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.ToCountry).fieldValue;
          this.selectedOpenSearch.fromPortIds = [this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromPort).fieldValue];
          this.selectedOpenSearch.toPortIds = [this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.ToPort).fieldValue];
          this.selectedOpenSearch.date = this.dateConvert(new Date());
          this.isOpenSearch=this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromCountry).active;
        }else{
          this.isOpenSearch=this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromCountry).active;
          this.isDefaultValues=this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromCountry).enableDefaultValues;
        }         
        }
        this.isOpenSearchCallCompleted=true;
      });
    }else{
      this.isOpenSearchCallCompleted=true;
    }
  }
  
  areOpenSearcAndFormValuesSame() {
    var data: any = this.portForm.value;
    if (data.fromCountry.id != this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromCountry).fieldValue
      || data.toCountry .id != this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.ToCountry).fieldValue
      || data.fromPort != this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.FromPort).fieldValue as any
      || data.toPort != this.openSearches.find(z => z.fieldName == OpenSearchFinderFields.ToPort).fieldValue as any) {        
      return false;
    }
    return true;

  }

}
